import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DEFAULT_DATE_LOCALE } from "../../components/shared/utils/date.utils";
import { SharedState } from "./reducers-shared";



/**
 * Top level selector for the SharedState
 */
export const selectSharedState = createFeatureSelector<SharedState>('shared');


export const getSelectedLanguage = createSelector(
    selectSharedState,
    (state: SharedState) => state.selectedLanguage
);

/**
 * The locale of the UI language, ready to be given to Intl:
 * languageFilename ('it' / 'en') is already a valid BCP47 tag.
 */
export const getSelectedLocale = createSelector(
    getSelectedLanguage,
    (language) => language?.languageFilename || DEFAULT_DATE_LOCALE
);

export const getAvailableLanguages = createSelector(
    selectSharedState,
    (state: SharedState) => state.availableLanguages
);

export const getLoggedUser = createSelector(
    selectSharedState,
    (state: SharedState) => state.user
);

export const isLoading = createSelector(
    selectSharedState,
    (state: SharedState) => state.loading
);

export const isLogged = createSelector(
    selectSharedState,
    (state: SharedState) => state.logged
);

